// Utility functions related to Business Unit handling.
// Centralizes normalization logic to avoid duplication between components.

export function normalizeBusinessUnitId(raw: number | string | null | undefined): number | null {
  if (raw === null || raw === undefined) return null;
  const value = typeof raw === 'string' ? Number(raw) : raw;
  if (!Number.isSafeInteger(value) || value <= 0) return null;
  return value;
}
